import { render, staticRenderFns } from "./CursosList.vue?vue&type=template&id=35efa786&scoped=true&"
import script from "./CursosList.vue?vue&type=script&lang=js&"
export * from "./CursosList.vue?vue&type=script&lang=js&"
import style0 from "./CursosList.vue?vue&type=style&index=0&id=35efa786&lang=scss&scoped=true&"
import style1 from "./CursosList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35efa786",
  null
  
)

export default component.exports